import LogAs from './LogAs'
import LogAsOrigin from './LogAsOrigin'

export {
  LogAs,
  LogAsOrigin
}

export default LogAs
